const WhatsAppContent = {
  overview: {
    title: "inFlow WhatsApp AI",
    description:
      "Deploy intelligent WhatsApp AI agents that handle multi-turn conversations, order placement, customer inquiry resolution, and automated transactional alerts at global enterprise scale.",
    imageURL: "/images/products/WhatsApp-3D-Studio-Banner.png",
    screenURL: "/images/products/WhatsApp-3D-Studio-Banner.png",
  },
  demo: [
    {
      title: "Restaurant Agent",
      path: "/demo/restaurant-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Lets customers browse menus, book tables, and place delivery orders directly via WhatsApp, with instant confirmations.",
      ],
      url: "https://wa.me/+919566872907?text=Hi",
    },
    {
      title: "Order Intake Agent",
      path: "/demo/order-intake-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        " Captures orders from messages, voice notes, or images, verifies details, and syncs seamlessly with order management systems.",
      ],
      url: "https://wa.me/+6581342734?text=Hi",
    },
    {
      title: "University Agent",
      path: "/demo/university-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Engages students and parents on WhatsApp with quick answers on courses, admissions, and campus life, available 24/7.",
      ],
      url: "https://wa.me/+6594586274?text=Hi",
    },
    {
      title: "Retail Agent",
      path: "/demo/retail-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Enables shoppers to browse products, check availability, and place orders, while offering promotions and personalized recommendations.",
      ],
      url: "https://wa.me/+918056569401?text=Hi",
    },
    {
      title: "Dental Agent",
      path: "/demo/dental-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Simplifies appointment bookings, reminders, and treatment inquiries, creating a convenient patient experience on WhatsApp.",
      ],
      url: "https://wa.me/+914447455633?text=Hi",
    },
    {
      title: "Lead Generation Agent",
      path: "/demo/lead-generation-agent",
      tag: "text",
      image: "/images/products/demo-whatsApp.png",
      description: [
        "Qualifies leads through smart conversation flows, collects prospect details, and routes them instantly to sales teams.",
      ],
      url: "https://wa.me/+60147615674?text=Hi",
    },
     {
      title: "Expense Claim Agent ",
      path: "/demo/expense-claim-agent –",
      tag:"text",
      // image: "/Images/demo-whatsApp.png",
      description: [
        "Automates claim submissions via WhatsApp, extracting details from receipts and generating status updates in real time.",
      ],
      url: "https://wa.me/+6580699247?text=Hi",
    },
    {
      title: "Customer Support Agent",
      path: "/demo/customer-support-agent",
      tag:"text",
      // image: "/Images/demo-whatsApp.png",
      description: [
        " Provides L1 support, raises tickets, shares status updates and logs feature requests, all on WhatsApp.",
      ],
        url: "https://wa.me/+6580854159?text=Hi",
      },
      {
      title: "WhatsApp calling",
      path: "/demo/whatsapp-calling",
      // image: "/Images/demo-whatsApp.png",
      tag:"voice",
      description: [
        " Business or customer initiated WhatsApp calls with AI voice support, seamless live agent escalation, and faster resolution end to end.",
      ],
        url: "https://test-whatsapp-calling.inextlabs.ai",
      },
      {
      title: "Healthcare Assistant",
      path: "/demo/healthcare-assistant",
      tag:"text",
      // image: "/Images/demo-whatsApp.png",
      description: [
        "AI assistant for general queries, doctor discovery, appointment booking, rescheduling, reminders, and patient support on WhatsApp.",
      ],
      url: "https://wa.me/+916374015979?text=Hi",
    },
  ],
  customerstory: {
    stories: [
      {
        tag: "FOOD & BEVERAGE · SINGAPORE",
        client: "Leading Indian Restaurant in Singapore",
        stat: "Zero Rush Delays",
        image: "/images/resources/case-study/help-whatsapp.webp",
        title: "How a Leading Indian Restaurant in Singapore Automated Orders and Customer Queries",
        text: "High call volumes during peak hours and no automated way to handle orders and inquiries. iNextLabs EngageAI automated order processing and customer query handling across WhatsApp, Facebook Messenger, and Google Business Messages.",
        url: "https://inextlabs.ai/resources/singapore-indian-restaurant-automated-orders-engageai",
      },
      {
        tag: "RETAIL · SINGAPORE",
        client: "Leading Jewellery Retailer in Singapore",
        stat: "Lead Nurturing",
        image: "/images/resources/case-study/jewelry-case-study.webp",
        title: "How a Leading Jewellery Retailer in Singapore Increased Customer Engagement on WhatsApp",
        text: "Low customer engagement through traditional marketing channels. iNextLabs EngageAI enabled personalized WhatsApp broadcast messaging, automated lead nurturing, and increased brand awareness.",
        url: "https://inextlabs.ai/resources/singapore-jewellery-retailer-whatsapp-engagement",
      },
      {
        tag: "HOSPITALITY · INDIA",
        client: "Leading Business Hotel in Coimbatore",
        stat: "24/7 Support",
        image: "/images/resources/case-study/chetinaad.webp",
        title: "How a Leading Business Hotel in Coimbatore Automated Guest Communication",
        text: "Guests expected 24/7 personalized responses but the team could not cover all hours and channels manually. iNextLabs EngageAI enabled round-the-clock guest support across WhatsApp and Google Business Messages, improving booking conversions and reducing staff workload.",
        url: "https://inextlabs.ai/resources/coimbatore-business-hotel-guest-communication-engageai",
      },
    ],
  },
  resources: {
    diagrams: [
      {
        name: "InFlow WhatsApp Calling Flyer V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/WhatsApp Calling Flyer V3.0.pdf",
        size: "PDF · 820 KB",
        desc: "Native WhatsApp voice calling, speech-to-text, and conversational AI agent orchestration.",
        isHero: true,
      },
      {
        name: "WhatsApp Smart Ordering Flyer V3.0",
        type: "pdf",
        tag: "PDF",
        image: "brochure/Smart Ordering V3.0.pdf",
        size: "PDF · 840 KB",
        desc: "Conversational commerce, interactive catalogs, and automated checkout inside WhatsApp.",
      },
      {
        name: "WhatsApp AI Calling Solution Flyer",
        type: "pdf",
        tag: "PDF",
        image: "brochure/EngageAl for Whatsapp calling New Flyer.pdf",
        size: "PDF · 533 KB",
        desc: "Detailed breakdown of SIP trunking, Meta Cloud API integration, and AI telephony pipelines.",
      },
      {
        name: "iNextLabs Corporate Overview Flyer V4",
        type: "pdf",
        tag: "PDF",
        image: "brochure/_iNextLabs Corporate Flyer V4_compressed.pdf",
        size: "PDF · 2.0 MB",
        desc: "Complete company overview, enterprise AI platform capabilities, and partner ecosystem.",
      },
      {
        name: "WhatsApp Bot Architecture",
        type: "diagram",
        tag: "DIAGRAM",
        image: "architecture/WhatsApp_Bot_Architecture.png",
        size: "PNG · 410 KB",
        desc: "End-to-end messaging pipeline, webhook integration, and LLM orchestration topology.",
      },
    ],
  },
};

export default WhatsAppContent;
